/***************************************************************************************************
** useModal
***************************************************************************************************/

import { useId, useState, useCallback, useEffect } from "react";

export default function useModal(name) {
  const idFallback = useId();
  const id = name || idFallback;

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((value) => !value), []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "";
    }
  }, [isOpen]);

  return {
    id,
    isOpen,
    toggle,
    open,
    close,
  };
}
